import { useTranslation } from 'react-i18next';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { exportDataServiceProviders, monitoringModule } from '../MonitoringDucks';
import Button from '../../../_ui/Button/Button';
import ExportIcon from '@material-ui/icons/SaveAlt';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  paper: {
    position: 'absolute',
    top: 9,
    right: 32
  },
  paperSm: {
    position: 'relative',
    marginTop: '10px',
    marginBottom: '20px'
  }
});

export default function ExportFile() {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();
  const matchesSm = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const loadingExport = useSelector(state => state[monitoringModule].loadingExport);
  const dataExport = () => {
    dispatch(exportDataServiceProviders());
  };

  return (
    <div className={matchesSm ? classes.paperSm : classes.paper}>
      <Button
        loading={loadingExport}
        style={{ marginLeft: 12 }}
        text={t('monitoring_export_btn')}
        icon={<ExportIcon fontSize="small" className="mr1" />}
        onClick={dataExport}
      />
    </div>
  );
}
